import {useUserSessionContext} from '../../../ui/sharedContexts/UserSessionContext';
import {useDropsSubscriptionsContext} from '../context/SubscriptionsProvider';
import {IsSubscribedEmailType} from '../types';

export const useIsIndividualDropSubscribed = (dropId: number | undefined) => {
  const {email} = useUserSessionContext();
  const {guest, ayUser} = useDropsSubscriptionsContext();

  if (!dropId) {
    return false;
  }

  return (
    isAyUserSubscribed(email, ayUser, dropId) ||
    isGuestSubscribed(email, guest, dropId)
  );
};

const isAyUserSubscribed = (
  email: string | undefined,
  ayUser: IsSubscribedEmailType | undefined,
  dropId: number,
) => {
  if (!ayUser) {
    return false;
  }

  // if current user is logged in
  if (ayUser.email === email) {
    // if there's subscription for current account email
    if (ayUser.individualDrops[dropId]) {
      return true;
    }
    // or if there's a subscription to another email but for this logged in user
    else if (
      Object.values(ayUser.customEmails || {}).find(subscribedDropIds =>
        subscribedDropIds.includes(dropId),
      )
    ) {
      return true;
    }
  }

  // if logged in with another user on the same machine
  // but there are still subscriptions for alternative emails
  if (
    Object.values(ayUser.customEmails || {}).find(subscribedDropIds =>
      subscribedDropIds.includes(dropId),
    )
  ) {
    return true;
  }

  return false;
};

const isGuestSubscribed = (
  email: string | undefined,
  guest: IsSubscribedEmailType | undefined,
  dropId: number,
) => {
  if (!guest || email) {
    return false;
  }

  return Boolean(guest.individualDrops[dropId]);
};
